import { useEffect, useState } from 'react';

import { MATRIX_GREEN } from '../constants';

interface Particle {
  id: number;
  char: string;
  left: number;
  delay: number;
  duration: number;
  size: number;
}

const CHARS = 'アイウエオカキクケコ01';

export function FloatingCodeParticles() {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    setParticles(
      Array.from({ length: 18 }, (_, i) => ({
        id: i,
        char: CHARS[Math.floor(Math.random() * 12)] ?? '0',
        left: 10 + Math.random() * 80,
        delay: Math.random() * 5,
        duration: 4 + Math.random() * 4,
        size: 10 + Math.random() * 6,
      }))
    );
  }, []);

  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      {particles.map((p) => (
        <span
          key={p.id}
          className='absolute font-mono'
          style={{
            left: `${p.left}%`,
            bottom: '-20px',
            fontSize: `${p.size}px`,
            color: `${MATRIX_GREEN}40`,
            textShadow: `0 0 6px ${MATRIX_GREEN}30`,
            animation: `float-up ${p.duration}s ${p.delay}s infinite linear`,
            opacity: 0,
          }}
        >
          {p.char}
        </span>
      ))}
    </div>
  );
}
